module.exports = __webpack_public_path__ + "img/l4.c60a2d62.png";